import { TextField, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import BrowseContactsDialog from "../../Components/Contacts/BrowseContactsDialog";
import { getWarehouses } from "../../Utils/Common";

export default function SupplierCompanyTab({
  setEditedValues,
  editedValues,
  edit,
  selectedWarehouse,
  otherWarehouses,
  newItem,
}) {
  const { t } = useTranslation();
  const [clientInfoObject, setClientInfoObject] = useState();
  const [warehouseLocation, setWarehouseLocation] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    getWarehouses(setWarehouseLocation, dispatch);
  }, [dispatch]);
  useEffect(() => {
    if (newItem) {
      if (editedValues?.StockItemSupplierDetail?.SupplierCompany) {
        setClientInfoObject({
          companyName:
            editedValues?.StockItemSupplierDetail?.SupplierCompany.name,
          companyId: editedValues?.StockItemSupplierDetail?.SupplierCompanyId,
        });
      }
      return;
    }
    if (
      selectedWarehouse && edit && selectedWarehouse === edit?.Warehouse.name
        ? edit.StockItemSupplierDetail?.SupplierCompany
        : otherWarehouses &&
          otherWarehouses.find(
            (o) =>
              o.StockItem.id === edit.StockItem.id &&
              o.Warehouse.name === selectedWarehouse
          )?.StockItemSupplierDetail?.SupplierCompany
    ) {
      setClientInfoObject({
        companyName:
          newItem && editedValues?.StockItemSupplierDetail?.SupplierCompany
            ? editedValues?.StockItemSupplierDetail?.SupplierCompany.name
            : selectedWarehouse &&
              edit &&
              selectedWarehouse === edit?.Warehouse.name
            ? edit.StockItemSupplierDetail?.SupplierCompany.name
            : otherWarehouses &&
              otherWarehouses.find(
                (o) =>
                  o.StockItem.id === edit.StockItem.id &&
                  o.Warehouse.name === selectedWarehouse
              )?.StockItemSupplierDetail?.SupplierCompany.name,
        companyId:
          newItem && editedValues?.StockItemSupplierDetail?.SupplierCompany
            ? editedValues?.StockItemSupplierDetail?.SupplierCompanyId
            : selectedWarehouse &&
              edit &&
              selectedWarehouse === edit?.Warehouse.name
            ? edit.StockItemSupplierDetail?.SupplierCompanyId
            : otherWarehouses &&
              otherWarehouses.find(
                (o) =>
                  o.StockItem.id === edit.StockItem.id &&
                  o.Warehouse.name === selectedWarehouse
              )?.StockItemSupplierDetail?.SupplierCompanyId,
      });
    }
  }, [selectedWarehouse]);

  return warehouseLocation ? (
    <Grid container key={selectedWarehouse + "SBT"}>
      <Grid item container xs={6} spacing={1}>
        <Grid item xs={12}>
          <Typography>
            {t("stockModule.supplierForWarehouse")}:{" "}
            {
              warehouseLocation.find((f) => f.value === selectedWarehouse)
                ?.label
            }
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <BrowseContactsDialog
            setClientInfoObject={(data) => {
              setClientInfoObject();
              data = {
                ...data,
                ...data.companyAdditionalInfo,
              };
              // This rehreshes the form
              setTimeout(() => {
                if (data && data.companyId) {
                  var obj = editedValues?.StockItemSupplierDetail || {};
                  obj.SupplierCompanyId = data.companyId;
                  obj.SupplierCompany = { name: data.companyName };
                  setEditedValues({
                    ...editedValues,
                    StockItemSupplierDetail: obj,
                  });
                }
                setClientInfoObject(data);
              }, 100);
            }}
            activeObject={
              clientInfoObject &&
              Object.values(clientInfoObject).find((v) => v !== "")
                ? clientInfoObject
                : undefined
            }
            resupply={true}
            label={
              <Typography
                style={{
                  textAlign: "left",
                  width: "100%",
                  textTransform: "none",
                }}
              >
                {clientInfoObject?.companyName || t("contactInfo.companyName")}
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label={t("stockModule.supplierProductCode")}
            defaultValue={
              selectedWarehouse &&
              edit &&
              selectedWarehouse === edit?.Warehouse.name
                ? edit.StockItemSupplierDetail?.productCode
                : otherWarehouses &&
                  otherWarehouses.find(
                    (o) =>
                      o.StockItem.id === edit.StockItem.id &&
                      o.Warehouse.name === selectedWarehouse
                  )?.StockItemSupplierDetail?.productCode
            }
            onChange={(e, v) => {
              var obj = editedValues?.StockItemSupplierDetail || {};
              obj.productCode = e.target.value;
              setEditedValues({
                ...editedValues,
                StockItemSupplierDetail: obj,
              });
            }}
            value={editedValues?.StockItemSupplierDetail?.productCode}
          ></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label={t("stockModule.linkToItemsProductPage")}
            defaultValue={
              selectedWarehouse &&
              edit &&
              selectedWarehouse === edit?.Warehouse.name
                ? edit.StockItemSupplierDetail?.url
                : otherWarehouses &&
                  otherWarehouses.find(
                    (o) =>
                      o.StockItem.id === edit.StockItem.id &&
                      o.Warehouse.name === selectedWarehouse
                  )?.StockItemSupplierDetail?.url
            }
            onChange={(e, v) => {
              var obj = editedValues?.StockItemSupplierDetail || {};
              obj.url = e.target.value;
              setEditedValues({
                ...editedValues,
                StockItemSupplierDetail: obj,
              });
            }}
            value={editedValues?.StockItemSupplierDetail?.url}
          ></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            inputProps={{ min: 0 }}
            defaultValue={
              selectedWarehouse &&
              edit &&
              selectedWarehouse === edit?.Warehouse.name
                ? edit.StockItemSupplierDetail?.deliveryTime
                : otherWarehouses &&
                  otherWarehouses.find(
                    (o) =>
                      o.StockItem.id === edit.StockItem.id &&
                      o.Warehouse.name === selectedWarehouse
                  )?.StockItemSupplierDetail?.deliveryTime
            }
            type="number"
            label={t("stockModule.averageDeliveryTime")}
            onChange={(e, v) => {
              var obj = editedValues?.StockItemSupplierDetail || {};
              obj.deliveryTime = e.target.value;
              setEditedValues({
                ...editedValues,
                StockItemSupplierDetail: obj,
              });
            }}
            value={editedValues?.StockItemSupplierDetail?.deliveryTime}
          ></TextField>
        </Grid>
      </Grid>
    </Grid>
  ) : null;
}
